import { render, staticRenderFns } from "./FeedbackResponses.vue?vue&type=template&id=351ac016&lang=pug"
import script from "./FeedbackResponses.vue?vue&type=script&lang=js"
export * from "./FeedbackResponses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports